module.exports = __webpack_public_path__ + "img/logo.79b4b2d3.png";